import axios, { AxiosError, AxiosInstance } from 'axios';
import { ApiResponse, ApiData, HistoryEntry } from '../types/api';

class ApiService {

    private async request<T>(
        method: 'GET' | 'POST' | 'PUT' | 'DELETE',
        url: string,
        data?: any
    ): Promise<ApiResponse<T>> {
        try {
            const response = await axios.request<ApiResponse<T>>({
                method,
                url,
                data,
            });

            return response.data;
        } catch (error) {
            const err = error as AxiosError<any>;
            return {
                success: false,
                message:
                err.response?.data?.message || `HTTP error! status: ${err.response?.status}`,
                error: err.response?.data?.error || err.message,
            };
        }
    }

    async getAllData(): Promise<ApiResponse<ApiData>> {
        return this.request<ApiData>('GET', '/time-gap/data');
    }

    async updateColumnValues(
        columnId: number,
        industryId: number,
        value: string
    ): Promise<ApiResponse<void>> {
        return this.request<void>('PUT', `/time-gap/${columnId}`, {
            industryId,
            value,
        });
    }

    async getGlobalHistory(): Promise<ApiResponse<HistoryEntry[]>> {
        return this.request<HistoryEntry[]>('GET', '/time-gap/history');
    }

    async getCellHistory(columnId: number, industryId: number): Promise<ApiResponse<HistoryEntry[]>> {
        return this.request<HistoryEntry[]>('GET', `/time-gap/history/${columnId}/${industryId}`);
    }

    async updateIndustryGoLive(
        industryId: number,
        numeroGoLive: string,
        name: string
      ): Promise<ApiResponse<void>> {
        return this.request<void>('PUT', `/time-gap/industry/${industryId}/go-live`, JSON.stringify({ numeroGoLive, name }));
      }
    
      async createIndustry(industryData: {
        name: string;
        numeroGoLive: string;
        fields: Record<string, string>;
      }): Promise<ApiResponse<void>> {
        return this.request<void>('POST','/time-gap/industry', JSON.stringify(industryData));
      }
}

export const apiService = new ApiService();
